<template>
<div class="card" v-loading="loading">
  <div class="card-header">
    <div class="row">
      <div class="col-md-6">
        <h4 class="card-title">
          <i class="ti-user"></i> Configurações do Projeto
        </h4>
      </div>

      <div class="col-md-6 text-right">
        <router-link :to="{name: 'project.edit'}">
          <button class="btn btn-wd btn-icon btn-info">
            <i class="ti-pencil-alt2"></i> Editar
          </button>
        </router-link>
      </div>
    </div>
    <div class="card-content">
      <div
        class="row"
        v-loading="!config"
      >
        <div class="col-md-12">
          <h5>Imagens</h5>
          <table class="table images">
            <thead>
            <th>Imagem no termo de lâmpada</th>
            <th>Imagem no termo de comodato</th>
            <th>Imagem no protocolo de entrega</th>
            <th>Imagem topo esquerdo do apresentador</th>
            <th>Imagem topo direito do apresentador</th>
            </thead>
            <tbody>
            <tr>
              <td>
                <img
                  :src="urlImages.imgTermLamp"
                  alt="img-term-lamp"
                  class="img-responsive"
                >
              </td>
              <td>
                <img
                  :src="urlImages.imgTermLending"
                  class="img-responsive"
                  alt="img-term-lamp"
                >
              </td>
              <td>
                <img
                  :src="urlImages.imgTermDelivery"
                  class="img-responsive"
                  alt="img-term-lamp"
                >
              </td>
              <td>
                <img
                  :src="urlImages.imgPresenterLeft"
                  class="img-responsive"
                  alt="img-term-lamp"
                >
              </td>
              <td>
                <img
                  :src="urlImages.imgPresenterRight"
                  class="img-responsive"
                  alt="img-term-lamp"
                >
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-12">
          <h5>Configurações gerais</h5>
          <table class="table">
            <tbody>
            <tr>
              <td>Nome:</td>
              <td>{{ config.name }}</td>
            </tr>
            <tr>
              <td>Link do Cadastro Online do projeto:</td>
              <td><a :href="config.projectOnlineRegister" target="_blank" rel="noopener noreferrer">{{ config.projectOnlineRegister }}</a></td>
            </tr>
            <tr>
              <td>Estado:</td>
              <td>{{ config.state }}</td>
            </tr>
            <tr>
              <td>Companhias dos termos:</td>
              <td>{{ config.companyTerms.toUpperCase() }}</td>
            </tr>
            <tr>
              <td>Terá pesquisa:</td>
              <td>{{ config.haveSurveys.toString() }}</td>
            </tr>
            <tr>
              <td>Tipo padrão de ganhadores nos evento.</td>
              <td>{{ config.defaultWinnerChoiceMode === 'lottery' ? 'Sorteio' : 'Ranking' }}</td>
            </tr>
            <tr>
              <td>Exibir mapa na página inicial?</td>
              <td>{{ config.viewGoogleMap.toString() }}</td>
            </tr>
            <tr>
              <td>Verificação de cliente duplicado:</td>
              <td>{{ Object.keys(config.validationCustomer).join(', ') }}</td>
            </tr>
            <tr>
              <td>Verificação de cliente contemplado anteriormente:</td>
              <td>{{ Object.keys(config.validationContemplatedCustomer).join(', ') }}</td>
            </tr>
            <tr>
              <td>O NIS será obrigarótio?</td>
              <td>{{ config.requiredNIS.toString() }}</td>
            </tr>
            <tr>
              <td>Usar processo da LGPD?</td>
              <td>{{ config.useLGPD.toString() }}</td>
            </tr>
            </tbody>
          </table>

          <h5>Configurações de Eventos</h5>
          <table class="table">
            <tbody>
            <tr>
              <td>Os eventos terão <strong>cerimônia?</strong></td>
              <td>{{ config.event.hasCeremony.toString() }}</td>
            </tr>
            <tr>
              <td> A <strong>substituição</strong> do cliente sorteado será:</td>
              <td>{{ config.event.automaticReplacement.toString() }}</td>
            </tr>
            <tr>
              <td>A <strong>data</strong> de recebimento no
                <strong>protocolo de entrega</strong>(termo de entrega) será manual ou automática?
              </td>
              <td>{{ config.event.autoDateOnDeliveryTerm ? 'Automática' : 'Manual' }}</td>
            </tr>
            <tr>
              <td>Será permitido <strong>sortear cliente já contemplados</strong>
                  anteriormente?
              </td>
              <td>{{ config.event.customersCanBeRecontemplated.toString() }}</td>
            </tr>
            <tr>
              <td><strong>Por quantos anos</strong> os clientes
                <strong>serão</strong> considerados como
                <strong>contemplados?</strong></td>
              <td>{{ config.event.contemplatedPeriod }}</td>
            </tr>
            <tr>
              <td>Haverá <strong>envio de fotos</strong> no evento?</td>
              <td>{{ config.event && config.event.hasPhotos ?  config.event.hasPhotos.toString() : '' }}</td>
            </tr>
            <tr>
              <td>Haverá <strong>cadastro de clientes via planilha</strong>?</td>
              <td>{{ config.event && config.event.managedCsv ? config.event.managedCsv.toString() : '' }}</td>
            </tr>
            </tbody>
          </table>

          <h5>Configurações de Registro</h5>
          <table class="table">
            <tbody>
            <tr>
              <td>
                Exibir campo de <strong>profissão</strong>?
              </td>
              <td>{{ config.register.carrer ? 'Sim' : 'Não' }}</td>
            </tr>
            </tbody>
          </table>

          <h5>Configurações de Lâmpadas</h5>
          <table class="table">
            <tbody>
            <tr>
              <td><strong>Potência das lâmpadas entregues na troca</strong></td>
              <td>{{ config.lamps.powerLampDeliveryLabel }}W</td>
            </tr>
            <tr>
              <td><strong>Quantidade máxima no projeto</strong>
                de lâmpadas a serem trocadas <strong>por cliente:</strong></td>
              <td>{{ config.lamps.max }}</td>
            </tr>
            <tr>
              <td>Haverá <strong>controle</strong> de lâmpadas por temporada?</td>
              <td>{{ config.lamps.hasSeason.toString() }}</td>
            </tr>
            <tr>
              <td>Período máximo <strong>(em meses)</strong> que o cliente ficará sem poder trocar lâmpada</td>
              <td>{{ config.lamps.hasSeason ? config.lamps.seasonRange : 'indeterminado' }}</td>
            </tr>
            </tbody>
          </table>


          <h5>Configurações de Tickets</h5>
          <table class="table">
            <tbody>
            <tr>
              <td>O <strong>código de barra</strong> será manual ou automático?</td>
              <td>{{ config.ticket.automaticBarcode.toString() }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'project-index',

  mounted () {
    this.fetchOne('config')
    this.getImagesProject()
  },

  computed: {
    ...mapGetters('project', {
      config: 'project',
      loading: 'loading'
    }),
    urlImages: {
      get: function () {
        return this.$store.state.project.urlImages
      }
    }
  },

  methods: {
    ...mapActions('project', ['fetchOne', 'getImagesProject'])
  }
}
</script>

<style scoped>
  td:nth-child(odd) {
    font-weight: bolder;
  }

  td:nth-child(even) {
    width: 30%;
  }
  img {
    max-height: 100px;
    width: auto !important;
  }
  table.images > thead > th {
    max-width: 150px;
    height: auto;
    text-align: center;
  }
  table.images > tbody > tr > td {
    width: auto !important;
    text-align: center !important;
  }
  table.images > tbody > tr > td > img{
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Project/ProjectIndex.vue